import type { BoundMethod } from "@/modules/billing/BoundMethod.ts";
import { atomWithLocalStorage } from "@/utils/jotai/atomStorage.ts";

export const lastUsedMethodId = atomWithLocalStorage<BoundMethod["id"] | undefined>("lastUsedMethodId", undefined);
